module.exports = __webpack_public_path__ + "static/media/Generic Assessments.d4a7e44f.png";